import React from 'react';
import { Button, Flex, Img, Input } from '../../../../flayr-components';
import useComponentContext from '../../../../hooks/useComponentContext';
import Logo from '../../../../lib/Logo/Logo';
import PhoneInput, { isValidPhoneNumber } from 'react-phone-number-input';
import { isEmailValid } from '../../../../utils';
import useSteps from '../../../../hooks/useSteps';
import DatePicker from '../../../../lib/DatePicker/DatePicker';
interface ICustomerDetailsProps {
  customerDetails?: any;
  providerDetails?: any;
  onChange?: (e?: any) => void;
  onSubmit?: (e?: any) => void;
}

const CustomerDetails: React.FC<React.PropsWithChildren<ICustomerDetailsProps>> = ({
  customerDetails,
  providerDetails,
  onChange,
  onSubmit,
}) => {
  const { step, next } = useSteps(['providerDetails', 'details']);
  const { phoneInput } = useComponentContext();

  function handlePhoneInputChange(value) {
    onChange?.({ target: { name: 'mobile', value } });
  }

  return (
    <div className="grid w-10/12 gap-5 mx-auto md:w-7/12 md:pt-12">
      <div className="mb-6 text-center">
        <Logo size="text-4xl" />
      </div>

      {step === 'providerDetails' && (
        <div>
          <div className="mx-auto">
            {!!providerDetails?.photo && (
              <Img
                src={providerDetails?.photo}
                size="96x96"
                round
                className="mx-auto shadow"
              />
            )}
          </div>
          <div className="mt-12 text-2xl font-medium text-center">
            Leave a review for {providerDetails.name}
          </div>

          <div className="mt-12 text-center">
            <Button onClick={next} size="lg" color="dark">
              Start Review
            </Button>
          </div>
        </div>
      )}

      {step === 'details' && (
        <>
          <Input
            name="name"
            placeholder="Enter Your Name"
            inputBg="bg-white"
            size="lg"
            mb="0"
            value={customerDetails.name}
            onChange={onChange}
            validation={['required']}
          />

          <PhoneInput
            defaultCountry={
              providerDetails.countryCode?.toUpperCase() ||
              phoneInput?.defaultCountry
            }
            placeholder="Enter your mobile"
            name="mobile"
            inputComponent={Input}
            onChange={handlePhoneInputChange}
            value={customerDetails.mobile}
            numberInputProps={{
              size: 'lg',
              inputBg: 'bg-white',
              validation: ['required'],
            }}
          />

          <Input
            type="email"
            name="email"
            placeholder="Enter Your Email"
            inputBg="bg-white"
            size="lg"
            mb="0"
            value={customerDetails.email}
            onChange={onChange}
            validation={['required', 'email']}
          />

          <DatePicker
            name="reviewDate"
            value={customerDetails.reviewDate}
            onChange={onChange}
            position="absolute"
            closeOnBodyClick
            inputClassName="!bg-white"
            enablePastDates
            placeholder={`When did you last use ${providerDetails?.name}?`}
          />

          <div className="text-right">
            <Button
              size="lg"
              color="dark"
              onClick={onSubmit}
              disabled={
                !(
                  customerDetails?.name &&
                  customerDetails?.mobile &&
                  isValidPhoneNumber(customerDetails.mobile) &&
                  isEmailValid(customerDetails.email) &&
                  customerDetails.reviewDate
                )
              }
            >
              Next
            </Button>
          </div>
        </>
      )}
    </div>
  );
};
export default CustomerDetails;
